import Vista from "../../components/Vista"
import { CircularProgress, Grid } from "@mui/material"
import { EstilosButton, productDetails } from "../../utils/styles"
import { useHistory } from "react-router-dom"
import { useLocalStorage } from "../../hooks/useLocalStorage"
import { NavLink } from "react-router-dom/cjs/react-router-dom.min"
import { useEffect, useState } from "react"
import Input from "../../components/Input"
import { LoadingButton } from "@mui/lab"
import Servo from "../../services/servo"
import { useMessages } from "../../hooks/useMessages"

let vs = productDetails()
let VS2 = EstilosButton()

const Detail = ({ match }) => {
  let EstilosButton = VS2()
  let productDetails = vs()
  const history = useHistory()
  const formDefault = {
    marca: ""
  }
  const { setMessages } = useMessages()
  const permisoCheck = "marcas"
  const [permiso] = useLocalStorage("permiso", null)
  const id = match?.params?.id
  const editado = !!id
  const [loadingB, setLoadingB] = useState(false)
  const [loading, setLoading] = useState(false)
  const [formDetails, setformDetails] = useState({ ...formDefault })

  const getDatos = async () => {
    setLoading(true)
    let res = await Servo.get(permisoCheck + "?idMarca=" + id)
    if (res.cuerpo?.resultado?.length > 0) {
      setformDetails((prevFormDetails) => ({
        ...prevFormDetails,
        ...res.cuerpo?.resultado[0]
      }))
    }
    setLoading(false)
  }

  useEffect(() => {
    if (editado) {
      getDatos()
    }
  }, [])

  const guardar = async () => {
    setLoadingB(true)
    let body = { ...formDetails }
    if (editado) {
      body = { ...formDetails, idMarca: id }
    }
    let res = await Servo.post(
      permisoCheck + "/guardar",
      body,
      permisoCheck,
      true,
      history
    )
    if (res?.cuerpo) {
      setMessages(res?.cuerpo)
    }
    setLoadingB(false)
  }

  return (
    <Vista>
      <div className={productDetails.screenSize}>
        <div className={productDetails.volverCarros}>
          {(permiso[permisoCheck] & 1) === 1 ? (
            <NavLink exact to={"/" + permisoCheck}>
              « Volver
            </NavLink>
          ) : (
            <p>« Volver</p>
          )}
        </div>
        <div className={productDetails.top}>
          <div className={productDetails.title}>
            {editado ? <p>Editar Marca</p> : <p>Nueva Marca</p>}
          </div>
        </div>
        <div className={productDetails.formArea}>
          <Grid container direction="row" columns={{ xs: 12, sm: 12, md: 12 }}>
            {!loading ? (
              <>
                <Grid
                  item
                  xs={12}
                  sm={4}
                  md={4}
                  sx={{
                    "@media (min-width: 600px)": {
                      paddingRight: "10px"
                    }
                  }}
                  className={productDetails.inputArea}
                >
                  <Input
                    typeInput={"form"}
                    valor={formDetails?.marca}
                    setValor={setformDetails}
                    placeholder="Marca"
                    nombre="Marca"
                    required="true"
                    onChange={(e) => {
                      setformDetails({
                        ...formDetails,
                        marca: e.target.value
                      })
                    }}
                  />
                </Grid>
              </>
            ) : (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                sx={{
                  "@media (min-width: 600px)": {
                    margin: "100px"
                  }
                }}
                className={productDetails.inputArea}
              >
                <CircularProgress />
              </Grid>
            )}
          </Grid>
        </div>
        <div className={productDetails.buttonArea}>
          {(permiso[permisoCheck] & 2) === 2 ? (
            <LoadingButton
              loading={loadingB}
              onClick={guardar}
              sx={{
                width: "170px",
                height: "50px",
                backgroundColor: "#157CC1",
                fontFamily: "poppins",
                borderRadius: "10px",
                border: "none",
                fontWeight: "500",
                fontSize: "14px",
                letterSpacing: "0.07em",
                color: "#FFFFFF",
                marginLeft: "2px",
                "@media (min-width: 600px)": {
                  marginBottom: "6px"
                },
                "&:hover": {
                  backgroundColor: "#1565c0",
                  cursor: "pointer"
                }
              }}
            >
              GUARDAR
            </LoadingButton>
          ) : (
            <LoadingButton
              onClick={guardar}
              disabled
              sx={{
                width: "170px",
                height: "50px",
                backgroundColor: "#157CC1",
                fontFamily: "poppins",
                borderRadius: "10px",
                border: "none",
                fontWeight: "500",
                fontSize: "14px",
                letterSpacing: "0.07em",
                color: "#FFFFFF",
                marginLeft: "2px",
                "@media (min-width: 600px)": {
                  marginBottom: "6px"
                },
                "&:hover": {
                  backgroundColor: "#1565c0",
                  cursor: "pointer"
                }
              }}
            >
              GUARDAR
            </LoadingButton>
          )}
        </div>
      </div>
    </Vista>
  )
}

export default Detail
